import { render, staticRenderFns } from "./legalDetailsView.vue?vue&type=template&id=1bb15268&"
import script from "./legalDetailsView.vue?vue&type=script&lang=js&"
export * from "./legalDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports